module.exports = __webpack_public_path__ + "static/media/messaging.54c8046c.svg";